var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1250_14142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5233 5.26276H7.47674C3.34745 5.26276 0 8.6102 0 12.7395V23.2605C0 27.3898 3.34745 30.7373 7.47674 30.7373H28.5233C32.6526 30.7373 36 27.3898 36 23.2605V12.7395C36 8.6102 32.6526 5.26276 28.5233 5.26276ZM23.4668 18.5119L13.6227 23.207C13.3603 23.3321 13.0574 23.1408 13.0574 22.8502V13.1667C13.0574 12.8719 13.3683 12.6809 13.6312 12.8142L23.4753 17.8027C23.768 17.951 23.7629 18.3707 23.4668 18.5119Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1250_14142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeWhiteIcon);
export default __webpack_public_path__ + "static/media/youtubeWhiteIcon.bd5b5cf7e51079ecd0c7075e9137732d.svg";
export { ForwardRef as ReactComponent };